import { CascadiaButtonProps } from "@certn/cascadia/components/button/types";

import { _Button, ButtonProps } from "./_Button";

interface Props extends CascadiaButtonProps {
  iconFillOverride?: ButtonProps["iconFillOverride"];
  variant?: "success" | "info" | "danger" | "warning" | "brand-primary";
  className?: string;
}

/** @deprecated Please update import to `@certn/cascadia` to add cross-platform support. See CHEESE-213 for more details. */
export function PrimaryButton(props: Props) {
  const {
    variant = "brand-primary",
    testID = "primary-button",
    className,
    ...buttonProps
  } = props;

  return (
    <_Button
      color={variant === "brand-primary" ? "text-on-brand" : "text-inverse"}
      fill={`background-${variant}-strong`}
      focusStyle="focus-action"
      hoverFill={`background-${variant}-strong-hover`}
      shadow="shadow-button"
      testID={testID}
      className={className}
      {...buttonProps}
    />
  );
}
